module.exports = __webpack_public_path__ + "static/media/deep-thoughts.22ddfceb.jpg";